<template>
  <div>
    <welcome-toolbar></welcome-toolbar>

    <div class="mx-10 mt-8">
      <v-card outlined>
        <v-tabs background-color="transparent" v-model="tab" align-with-title>
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :data-cy="`widgetTab_${widget.value}`"
            @click="changeTab(widget)"
            class="mx-0"
            color="grey"
            link
            v-for="(widget, index) in filteredWidgetList"
            :key="index"
          >
            {{ widget.label }}
            <v-tooltip t>
              <template v-slot:activator="{ on }">
                <div v-on="on" v-show="widget.componentName === 'WidgetPublicationIssues' && issueCount">
                  <v-badge :content="issueCount" bordered class="ml-1 mb-2" color="red"></v-badge>
                </div>
              </template>
              <span
                >Number of release notes where the status is not Cancelled, Pulled, or Published and where the pack is
                not In Process
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  v-show="widget.componentName === 'WidgetMyReleaseNotes' && releaseNotesNeedingAttentionCount"
                >
                  <v-badge
                    :content="releaseNotesNeedingAttentionCount"
                    bordered
                    class="ml-1 mb-2"
                    color="red"
                  ></v-badge>
                </div>
              </template>
              <span>Number of release notes with status Corrections Indicated or Pending Peer Review</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" v-show="widget.componentName === 'WidgetUATJira' && uatJiraCount">
                  <v-badge :content="uatJiraCount" bordered class="ml-1 mb-2" color="red"></v-badge>
                </div>
              </template>
              <span>Number of published release notes that do not have a UAT Jira</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>
        <v-tabs-items class="mt-2" v-model="tab">
          <v-tab-item eager v-for="(widget, index) in filteredWidgetList" :key="index">
            <v-card outlined>
              <v-card-text class="px-0">
                <component
                  :is="widget.componentName"
                  @releaseNotesNeedingAttentionCount="setReleaseNotesNeedingAttentionCount"
                  @publicationIssueCount="setPublicationIssueCount"
                  @uatJira="setUATJiraCount"
                ></component>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import WelcomeToolbar from "./WelcomeToolbar";
import WidgetActivePackList from "./WidgetActivePackList";
import WidgetImplementLaterList from "./WidgetImplementLaterList";
import WidgetMyReleaseNotes from "./qa/WidgetMyReleaseNotes";
import WidgetPublicationIssues from "./qa/WidgetPublicationIssues";
import WidgetUATJira from "./qa/WidgetUATJira.vue";

export default {
  components: {
    WelcomeToolbar,
    WidgetActivePackList,
    WidgetImplementLaterList,
    WidgetMyReleaseNotes,
    WidgetPublicationIssues,
    WidgetUATJira,
  },
  computed: {
    filteredWidgetList() {
      return this.widgetList
        .map(widget => {
          if (!widget.permission) {
            widget.permission = false;
            return widget;
          }
          widget.permission = this[widget.permission];
          return widget;
        })
        .filter(widget => widget.permission);
    },
    currentWidget() {
      return this.$route.query.widget;
    },
    currentWidgetComponentName() {
      const widget = this.filteredWidgetList.find(widget => widget.value === this.currentWidget);
      if (!widget) {
        return;
      }

      return widget.componentName;
    },
    ...mapGetters({
      hasWidgetActivePacksView: "session/hasWidgetActivePacksView",
      hasWidgetImplementLaterView: "session/hasWidgetImplementLaterView",
      hasWidgetMyReleaseNoteView: "session/hasWidgetMyReleaseNoteView",
      hasWidgetPublicationIssuesView: "session/hasWidgetPublicationIssuesView",
    }),
    ...mapState({
      isOchinUser: state => state.session.user.isOchinUser,
    }),
  },
  created() {
    if (!this.currentWidget) {
      this.$router.push({ query: { widget: "activePacksAtAGlance" } });
    } else {
      this.setTabToCurrentWidget();
    }
  },
  data() {
    return {
      activeWidget: null,
      releaseNotesNeedingAttentionCount: 0,
      issueCount: 0,
      uatJiraCount: 0,
      widgetName: null,
      widgetList: [
        {
          componentName: "WidgetActivePackList",
          label: "Active Packs at a Glance",
          value: "activePacksAtAGlance",
          permission: "hasWidgetActivePacksView",
        },
        {
          componentName: "WidgetMyReleaseNotes",
          label: "My Release Notes",
          value: "releaseNotes",
          permission: "hasWidgetMyReleaseNoteView",
        },
        {
          componentName: "WidgetPublicationIssues",
          label: "Publication Issues",
          value: "publicationIssues",
          permission: "hasWidgetPublicationIssuesView",
        },
        {
          componentName: "WidgetImplementLaterList",
          label: "Implement Later List",
          value: "implementLaterList",
          permission: "hasWidgetImplementLaterView",
        },
        {
          componentName: "WidgetUATJira",
          label: "UAT Jira Missing",
          value: "uatJiraMissing",
          permission: "hasWidgetPublicationIssuesView",
        },
      ],
      tab: 0,
    };
  },
  methods: {
    changeTab(widget) {
      if (this.currentWidget === widget.value) {
        return;
      }
      this.$router.push({ query: { widget: widget.value } });
    },
    setTabToCurrentWidget() {
      this.tab = this.filteredWidgetList.findIndex(widget => widget.value === this.currentWidget);
    },
    setReleaseNotesNeedingAttentionCount(val) {
      this.releaseNotesNeedingAttentionCount = val;
    },
    setPublicationIssueCount(val) {
      this.issueCount = val;
    },
    setUATJiraCount(val) {
      this.uatJiraCount = val;
    },
  },
  watch: {
    currentWidget(val) {
      if (!val) {
        this.$router.push({ query: { widget: this.filteredWidgetList[0].value } });
      }
      this.setTabToCurrentWidget();
    },
  },
};
</script>
